<template>
  <!--
    	作者：kmdshop
    	时间：2020-04-26
    	描述：门店-添加门店
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="80px">
      <!--添加门店-->
      <div class="common-form">添加门店</div>

      <el-form-item label="选择用户">
        <el-row>
          <el-button @click="addClick" icon="el-icon-plus">选择会员</el-button>
          <div v-if="form.user_id!=''" class="img">
            <img :src="user_info.avatarUrl" width="100" height="100" />
            <div>{{ user_info.nickName }}</div>
          </div>
          <!-- <div>
            门店添加成功后，该用户自动成为店长
          </div> -->
        </el-row>
      </el-form-item>

      <el-form-item label="门店名称" prop="store_name" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.store_name" placeholder="请输入门店名称" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="门店logo">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload">选择图片</el-button>
          <div v-if="form.logo!=''" class="img">
            <img :src="form.logo" width="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="联系人" prop="linkman" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.linkman" placeholder="请输入门店联系人" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="phone" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.phone" placeholder="请输入门店联系电话" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="客服联系电话" prop="cs_phone">
        <el-input v-model="form.cs_phone" placeholder="请输入客服联系电话" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="营业开始时间" prop="shop_hours_start" >
        <el-input v-model="form.shop_hours_start" placeholder="请输入营业开始时间,例如:8:30" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="营业结束时间" prop="shop_hours_end" >
        <el-input v-model="form.shop_hours_end" placeholder="请输入营业结束时间,例如:17:30" class="max-w460"></el-input>
      </el-form-item>

      <!-- <el-form-item label="店铺二维码">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('qrcode')">选择图片</el-button>
          <div v-if="form.store_qrcode!=''" class="img">
            <img :src="form.store_qrcode" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="小程序appid" prop="store_wxappid" >
        <el-input v-model="form.store_wxappid" placeholder="请输入小程序appid" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="小程序页面路径" prop="store_wxapp_url" >
        <el-input v-model="form.store_wxapp_url" placeholder="请输入小程序页面路径" class="max-w460"></el-input>
        <div class="help">不填写则直接进入首页</div>
      </el-form-item> -->

      <el-form-item label="门店区域">
        <el-select v-model="form.province_id" placeholder="省" @change="initCity">
          <el-option :label="item.name" :value="item.id" v-for="(item,index) in areaList" :key='index'></el-option>
        </el-select>
        <el-select v-if="form.province_id!=''" v-model="form.city_id" placeholder="市" @change="initRegion">
          <el-option :label="item1.name" :value="item1.id" v-for="(item1,index1) in areaList[form.province_id]['city']"
            :key='index1'></el-option>
        </el-select>
        <el-select v-if="form.city_id!=''" v-model="form.region_id" placeholder="区">
          <el-option :label="item2.name" :value="item2.id" v-for="(item2,index2) in areaList[form.province_id]['city'][form.city_id]['region']"
            :key='index2'></el-option>
        </el-select>
        <!--<el-select v-if="form.region_id > 0" v-model="form.town_id" placeholder="镇">-->
        <!--  <el-option :label="item3.name" :value="item3.id" v-for="(item3,index3) in areaList[form.province_id]['city'][form.city_id]['region'][form.region_id]['town']"-->
        <!--    :key='index3'></el-option>-->
        <!--</el-select>-->
        <!--<el-select v-if="form.town_id > 0" v-model="form.village_id" placeholder="乡">-->
        <!--  <el-option :label="item4.name" :value="item4.id" v-for="(item4,index4) in areaList[form.province_id]['city'][form.city_id]['region'][form.region_id]['town'][form.town_id]['village']"-->
        <!--    :key='index4'></el-option>-->
        <!--</el-select>-->
      </el-form-item>
      <el-form-item label="详细地址" prop="address" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.address" placeholder="请输入详细地址" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="门牌号" prop="house_number" >
        <el-input v-model="form.house_number" placeholder="请输入门牌号" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="门店坐标">
        <el-row class="mb16">
          <el-col :span="24">
            <el-input v-model="form.coordinate" class="max-w460"></el-input>
          </el-col>
        </el-row>
        <el-row class="mb16">
          <el-col :span="24">
            <GetPoint :form="form" @getMapdata="getMapdataFunc" @chose="choseFunc"></GetPoint>
          </el-col>
        </el-row>
      </el-form-item>

      <!-- 选择门店服务 -->
      <el-form-item label="选择门店服务">
        <el-table 
          ref="serviceTable"
          :data="service" 
          border 
          size="mini" 
          style="width: 100%;"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="code" label="编号"></el-table-column>
          <el-table-column prop="name" label="类型名称" width="200"></el-table-column>
          <el-table-column label="排序">
            <template v-slot="scope">
              <el-input 
                v-model="scope.row.sort" 
                size="mini" 
                placeholder="排序" 
                style="width: 80px;"
                @change="updateServiceSort(scope.row)"
              ></el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>

      <!-- 已选服务列表（可选显示） -->
      <!-- <el-form-item label="已选服务" v-if="form.service.length > 0">
        <el-table :data="form.service" border size="mini" style="width: 100%;">
          <el-table-column prop="code" label="编号"></el-table-column>
          <el-table-column prop="name" label="类型名称" width="200"></el-table-column>
          <el-table-column prop="sort" label="排序"></el-table-column>
          <el-table-column label="操作" width="100">
            <template v-slot="scope">
              <el-button 
                type="text" 
                size="mini" 
                @click="removeService(scope.$index)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item> -->

      <el-form-item label="门店排序">
        <el-input type="number" v-model="form.sort" placeholder="请输入门店排序" class="max-w460"></el-input>
      </el-form-item>
      
      <el-form-item label="分销级别" >
        <el-select v-model="form.fx_level" multiple style="width: 400px;" placeholder="请选择">
          <el-option
            label="直推"
            value="0">
          </el-option>
          <el-option
            label="间推"
            value="1">
          </el-option>
          <el-option
            label="次推"
            value="2">
          </el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item label="备注">
        <el-input type="textarea" :rows="2" v-model="form.remark" placeholder="请输入备注" class="max-w460"></el-input>
      </el-form-item>
      
      <!-- <el-form-item label="自提核销">
        <el-radio-group v-model="form.is_check">
          <el-radio :label="1">支持</el-radio>
          <el-radio :label="0">不支持</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item label="门店状态">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="是否通过">
        <el-radio-group v-model="form.audit_status">
          <el-radio :label="1">通过</el-radio>
          <el-radio :label="2">不通过</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="不通过理由" prop="reject_reason" v-if="form.audit_status == 2">
        <el-input v-model="form.reject_reason" placeholder="请输入不通过理由" class="max-w460"></el-input>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>

    <!--添加-->
    <GetUser :is_open="open_add" @close="closeDialogFunc"></GetUser>
  </div>
</template>

<script>
  import GetPoint from '@/components/map/Getpoint.vue';
  import StoreApi from '@/api/store.js';
  import select_region from '@/utils/select.district.js';
  import Upload from '@/components/file/Upload';
  import { formatModel } from '@/utils/base.js'
  import GetUser from '@/components/user/GetUser.vue';
  
  export default {
    components: {
      /*腾讯地图拾取器*/
      GetPoint,
      Upload,
      GetUser
    },
    data() {
      return {
        /*form表单数据*/
        form: {
          store_name: '',
          logo_image_id: 0,
          logo: "",
          linkman: '',
          phone: '',
          shop_hours: '',
          shop_hours_start: "",
          shop_hours_end: '',
          province_id: '',
          city_id: '',
          region_id: '',
          town_id: '',
          village_id: '',
          address: '',
          house_number: "",
          coordinate: '',
          summary: '',
          sort: 1,
          is_check: 1,
          status: 1,
          store_qrcode: '',
          store_wxapp_url: '',
          store_wxappid: '',
          is_search_map: false,
          audit_status: 1, //1   通过  2  驳回
          reject_reason: "", //不通过理由
          cs_phone: "",
          service: [], // 已选服务
          fx_level: [],
          remark: "",
          user_id: 0,
        },
        file_path: '',
        /*省市区*/
        areaList: select_region,
        /*是否上传图片*/
        isupload: false,
        loading: false,
        file_type: '',
        user_info: {},
        open_add: false,
        api_val: "", //门店名称/手机号
        service: [], // 所有可用的服务列表
      };
    },
    created() {
      this.getSetting();
    },
    methods: {
      // 获取服务设置
      getSetting() {
        var self = this;
        self.getSetting_common({
          "item": 'store_clerk',
        }, function(data) {
          // 初始化服务列表，为每个服务添加sort属性
          self.service = data.vars.values.service.map(item => ({
            ...item,
            sort: 0
          }));
        })
      },
      
      // 处理表格勾选变化
      handleSelectionChange(selectedRows) {
        // 获取当前勾选的所有服务code
        const selectedCodes = selectedRows.map(row => row.code);
        
        // 1. 移除取消勾选的服务
        this.form.service = this.form.service.filter(service => 
          selectedCodes.includes(service.code)
        );
        
        // 2. 添加新勾选的服务
        selectedRows.forEach(row => {
          if (!this.form.service.some(service => service.code === row.code)) {
            this.form.service.push({
              code: row.code,
              name: row.name,
              sort: row.sort || 0
            });
          }
        });
      },
      
      // 更新服务排序
      updateServiceSort(row) {
        const service = this.form.service.find(item => item.code === row.code);
        if (service) {
          service.sort = row.sort;
        }
      },
      
      // 删除已选服务
      removeService(index) {
        // 从已选列表中移除
        const removedService = this.form.service.splice(index, 1)[0];
        
        // 更新表格的勾选状态
        this.$nextTick(() => {
          const serviceRow = this.service.find(item => item.code === removedService.code);
          if (serviceRow) {
            this.$refs.serviceTable.toggleRowSelection(serviceRow, false);
          }
        });
      },

      /*打开弹出层*/
      addClick() {
        this.open_add = true;
      },

      /*关闭获取用户弹窗*/
      closeDialogFunc(e) {
        if (e.type != 'error') {
          this.user_info = e.params[0];
          this.form.user_id = e.params[0].user_id;
        }
        this.open_add = false;
      },
      
      queryStore() {
        // 创建一个新的浏览器窗口
        var newWindow = window.open('', '_blank');
        // 如果新窗口打开成功，设置新窗口的 location 属性
        if (newWindow) {
          newWindow.location.href = 'http://kmdapi.gzkcyj.com/shop/#/plus/oioc/index';
        } else {
          // 如果新窗口打开失败，可以在此处给用户提示或者执行其他操作
          alert('弹窗被阻止，请检查浏览器设置。');
        }
      },
      
      quickGet() {
        let self = this;
        self.loading = true;
        StoreApi.quickGetStore({
          api_val: self.api_val,
        }, true)
        .then(data => {
          self.loading = false;
          console.log('data', data)
          if (data.code == 1) {
            self.form.setting = data.data
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
      },
      
      /*添加用户*/
      onSubmit() {
        let self = this;
        let form = self.form;
        form.fx_level = JSON.stringify(self.form.fx_level);
        
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            StoreApi.addShop(form, true)
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，添加成功',
                  type: 'success'
                });
                self.$router.push('/store/store/index');
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
          }
        });
      },
      
      /*初始化城市id*/
      initCity() {
        this.form.city_id = ''
      },

      /*初始化区id*/
      initRegion() {
        this.form.region_id = ''
      },

      /*获取经纬度*/
      getMapdataFunc(e) {
        this.form.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
      },

      /*上传*/
      openUpload(e) {
        this.file_type = e;
        this.isupload = true;
      },

      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          if (this.file_type == 'qrcode') {
            this.form.store_qrcode = e[0].file_path;
          } else {
            this.form.logo = e[0].file_path;
          }
        }
        this.isupload = false;
      },

      /*选择的地址*/
      choseFunc(e) {
        this.form.coordinate = e.location.lat + ',' + e.location.lng;
        this.form.address = e.address;
      },

      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .basic-setting-content {}

  .product-add {
    padding-bottom: 50px;
  }

  .img {
    margin-top: 10px;
    
    div {
      margin-top: 5px;
      text-align: center;
    }
  }
  
  .max-w460 {
    max-width: 460px;
  }
  
  .mb16 {
    margin-bottom: 16px;
  }
</style>


// WEBPACK FOOTER //
// src/views/store/store/add.vue